/**
 * Created by Miguel on 23/05/2017
 */
declare global {
  interface Window {
    SpeechRecognition: any;
    webkitSpeechRecognition: any;
  }
}
import { Component,Input, OnInit, ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { THROW_IF_NOT_FOUND } from '@angular/core/src/di/injector';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../services/app-data.service';
import { CompanyService }  from '../../services/company.service';

//teleview
declare var $ : any;
declare var Swal : any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'chat-component',
    templateUrl:'chat.component.html',
})
export class ChatComponent implements OnInit {

  public recordRequested;

  public canAskContact=false;
  public privateMessages=[];
  public publicMessages=[];
  public messageLog={};
  public localMessages=[];
  public messages=[];
  public chatReference;
  public privateChatReference;
  public whereAmI='';
  public chatControl=0;
  public chatTab=false;
  public room;
  public ismobile;
  public firstTime=true;
  public privateRoomName='';
  public channel
  public lastMessage;

  public x=0;
  public y=0;
  public z=0;
  public direction="P";


/*record*/
public recorder: any = null;
public audioStream: any = null;
public audioChunks: Blob[] = [];
public isRecording: boolean = false;
public startTime: number = 0;
public elapsedTimeInterval: any = null;
public recognition: any = null;
public isRecognizing: boolean = false;
public finalTranscripts: string = '';
public lastSpeaker: string = 'Você: ';
public audioURL: string = '';
/*endrecord*/


  @Input() bigChat: boolean;

  constructor( public _sanitizer: DomSanitizer, public _appData : AppDataService, public _companyService: CompanyService) {
  }
  public ngOnDestroy() {

    if (this.bigChat){
      this.chatTab=true;
    }
  }
  
  // within a window load,dom ready or something like that place your:
  public ngOnInit() : any {
  }
  public userTiping(val){
    this._appData.tiping=val;
  }

  public openChatWindow(open){
  //  this.chatTab=open;
//      if (open){
//  $(".dashboard-nav").toggleClass("mobile-show");

  /*        $(this).closest(".dashboard-nav-dropdown")
              .toggleClass("show")
              .find(".dashboard-nav-dropdown")
              .removeClass("show");
          $(this).parent()
              .siblings()
              .removeClass("show");*/
              $(".dashboard").removeClass("dashboard-compact");
//              $(".dashboard-nav").addClass("mobile-show");
          $(".dashboard-nav-dropdown").addClass("show")
    //  }

  }
   public sendIframeMessage(messageKind){
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
  }
  public getStringDifference(stringA, stringB) {
    var cost = [],
      str1 = stringA,
      str2 = stringB,
      n = str1.length,
      m = str2.length,
      i, j;
  
    var minimum = function (a, b, c) {
      var min = a;
      if (b < min) {
        min = b;
      }
      if (c < min) {
        min = c;
      }
      return min;
    };
  
    if (n == 0) {
      return;
    }
    if (m == 0) {
      return;
    }
  
    for (i = 0; i <= n; i++) {
      cost[i] = [];
    }
  
    for (i = 0; i <= n; i++) {
      cost[i][0] = i;
    }
  
    for (j = 0; j <= m; j++) {
      cost[0][j] = j;
    }
  
    for (i = 1; i <= n; i++) {
  
      var x = str1.charAt(i - 1);
  
      for (j = 1; j <= m; j++) {
  
        var y = str2.charAt(j - 1);
  
        if (x == y) {
  
          cost[i][j] = cost[i - 1][j - 1];
  
        } else {
  
          cost[i][j] = 1 + minimum(cost[i - 1][j - 1], cost[i][j - 1], cost[i - 1][j]);
        }
  
      } //endfor
  
    } //endfor
  
    return cost[n][m];
  }
  public startRoom(){
    this.recordRequested=false;
    this.chatControl=0;
    if (this.chatReference){
      this.chatReference.off();
    }
    this.messages=this.messageLog[this.room];
    if (!this.messages) this.messages=[];
    this.chatReference=this._companyService.messageReadFromLocalPosition(this.room);
    this.chatReference.limitToLast(1).on("child_added", (snapshot, prevChildKey) =>{     
      let _messages=snapshot.val();
      _messages.key=snapshot.key;

      
      let lastmsg={_id:'aa',text:'none',user:{_id:-1}}
      if (this.messages.length>0){
        //test if the new message is new to this messages
        lastmsg=this.messages[this.messages.length-1];
      }
      if (_messages && _messages._id!=lastmsg._id){


          let pushed=false;
          if (!this._appData.localConference && _messages.channel){
            //need to test if it was close
            let myPosition=this._appData.instagramUser.position;
            let messagePosition=_messages.channel;
            if (Math.abs(myPosition.x-messagePosition.x)<=2 && Math.abs(myPosition.y-messagePosition.y)<=2 && Math.abs(myPosition.z-messagePosition.z)<=2){
              this.messages.push(_messages); 
              pushed=true;
            }

          }
          else{
            this.messages.push(_messages); 
            pushed=true;
          }

          this.lastMessage={text:_messages.text,time:_messages.createdAt};
          if (_messages.recording && pushed){
            //someone is recording
            if (!this.isRecording){
              //but i am not recording
              if (!this.recordRequested){
                //and didnt receive a request to record.
                Swal.fire({
                  title:'Você foi convidado a inicar transcrição',
                  text:'Você aceita iniciar transcrição?',
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "Sim",
                  denyButtonText: `Não`
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.value) {
                    this.startRecording();
                    this.recordRequested=false;
                    Swal.fire("Sucesso", "Seu audio está sendo gravado.", "success");
                  } else if (result.isDenied) {
                  }
                });
                this.recordRequested=true;
              }
            }
          }

          let hassound=false;
          if (this.messages.length>1){
            if (!this._appData.instagramUser) {
              hassound=true;
            }
            else{
              if (lastmsg.user._id != this._appData.instagramUser.uid){
                hassound=true
              }
            } 
          }
/*          if (hassound){
            if (document.hidden) {
              var audio = new Audio('/assets/game/sounds/message.mp3');
              audio.play();   
            }
          }*/
      }
        this.sendIframeMessage({kind:'chat',uid:_messages.user._id,message:_messages.text});
        this.openChatWindow(true);  
      //fase final. envie mensagem pra o chat correto.
      var objDiv2 = $("#chat-content");
      if (objDiv2){
        objDiv2.animate({
          scrollTop: objDiv2[0].scrollHeight
          }, 'fast');
          try{
            objDiv2.lastChild.scrollIntoView();           
          }
          catch(err){}
      }
    });

    return true;
  }
  public newMessage() {
    $('#message-control-tutorial').click();
    this.openChatWindow(true);
//      $('#chatMessageInput').blur();
    setTimeout(()=>{
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0; 
    },500);

      let userOnList=this._appData.instagramUser
      let message = $("#chatMessageInput").val();
      if (($.trim(message) == '') ) {
        return false;
      }
        
      $("#chatMessageInput").val('')
      let id=new Date();
      let link=this.isUrl(message);
      let channel={
        x:this._appData.instagramUser.position.x,
        y:this._appData.instagramUser.position.y,
        z:this._appData.instagramUser.position.z
      }
      let msgObj={
            _id: id.getTime(),
            createdAt: id.getTime(),
            text:message,
            event:this._appData.event.id.toString(),
            channel:channel,
            link:link,
            user:{
              _id: userOnList.uid,
              avatar: userOnList.profile_picture,
              name: userOnList.full_name,
              token:''
            }
      }
      if (userOnList.fcmToken){
        msgObj.user.token=userOnList.fcmToken;
      }
      var talkTo=userOnList.talkId;
      if (!talkTo) talkTo=""
      this._companyService.messageWriteToLocalPosition(this.room,msgObj)

      setTimeout(()=>{
        var objDiv = document.getElementById("chat-content");
        objDiv.scrollTop = objDiv.scrollHeight; 
      },500)

        
  }
  public gotoUser(user){
    this._appData.friendOnEvent={
      uid:user._id,
      full_name:user.name,
      profile_picture:""
    }
    $('#userInteractionModal').modal('show');
    $('#userInteractionModalClick').click();
  }

public newActionMessage(action) {
  let userOnList=this._appData.instagramUser
  var talkTo="";

  if (!userOnList){
    userOnList={};
    userOnList.full_name='Sem Nome'
    userOnList.profile_picture="/assets/landingstyle/profile.png"
    userOnList.uid=Math.random().toString();
    userOnList.talkId='';
  }
  if (userOnList.talkId){
    talkTo=userOnList.talkId;
  }
  let msg=action;
  let id=new Date();
  let link=this.isUrl(msg);
  let msgObj={
        _id: id.getTime(),
        createdAt: id.getTime(),
        text:msg,
        link:link,
        user:{
          _id: userOnList.uid,
          avatar: userOnList.profile_picture,
          name: userOnList.full_name
        }
      }

  if (this.chatControl==0){
    //send to everybody on 0
    this._companyService.messageWriteToLocalPosition(this.room,msgObj)
  }
  //send only to who is on 1
  else if (this.chatControl==1){
    this._companyService.messageWriteToLocalPosition(this.room,msgObj)
  }
  else{
    this._companyService.addRoomMessage(this._appData.room.id,talkTo,msgObj)
  }

};
public isUrl(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}
  public reloadChat(){
        //se eu tiver uma sala...eu tenho que comparar com a sala antiga       
      if (this._appData.room){
        let room=this._appData.room.id;
        if (this._appData.localConference){
          room=room+'-'+this._appData.localConference
        }
        //changing my messages. need to change the old ones
        if (!this.messageLog) {this.messageLog={};}

        //atualizo minha sala.
        this.room=room;
        this.startRoom();
        this.removeTextFocus();
        this.openChatWindow(false);
      }
  }
  public removeTextFocus(){
    $('#chatMessageInput').blur()
    $('#chatMobileMessageInput').blur()
    this._appData.tiping=false;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }



    /***************************
     * 
     * 
     * recording
     */
    public exportRecording(){
      // Content of the file
      let textContent = "";
      this.messages.forEach(v=>{
        textContent=textContent+v.user.name+':'+v.text+'\n';
      })

            
      // Create a Blob with the content
      const blob = new Blob([textContent], { type: 'text/plain' });
      
      // Create a link element
      const link = document.createElement('a');
      
      // Set the href attribute to a URL representing the Blob
      link.href = URL.createObjectURL(blob);
      
      // Set the download attribute with a filename
      link.download = 'sample.txt';
      
      // Programmatically click the link to trigger the download
      link.click();
      
      // Cleanup: revoke the object URL to free memory
      URL.revokeObjectURL(link.href);

    }
    public startRecording() {
      
      this.getAudioStream().then(() => {
        this.startRecognition(); // Chama a função de reconhecimento de fala
        this.startTime = Date.now();
        this.elapsedTimeInterval = setInterval(() => this.updateRecordingTime(), 1000);
        this.isRecording = true;
        this.updateButtonStates();
      }).catch((error) => {
        console.error('Erro ao iniciar gravação:', error);
      });
    }
    public stopRecording() {
      if ( this.isRecording) {
        clearInterval(this.elapsedTimeInterval);
        this.stopRecognition();
        this.isRecording = false;
        this.updateButtonStates();
      }
    }
    public getAudioStream() {
      if (!this.audioStream) {
        return navigator.mediaDevices.getUserMedia({ audio: true })
          .then((stream) => {
            this.audioStream = stream;
          })
          .catch((error) => {
            console.error('Erro ao acessar o microfone:', error);
          });
      }
      return Promise.resolve(this.audioStream);
    }
    public addAudioToList(audioURL: string) {
      const recordedAudiosDiv = document.getElementById('recordedAudios') as HTMLElement;
      const audioElement = document.createElement('audio') as HTMLAudioElement;
      audioElement.controls = true;
      audioElement.src = audioURL;
      recordedAudiosDiv.appendChild(audioElement);
      document.getElementById('audioContainer')!.style.display = 'block';
    }
    public startRecognition() {
      // Verifica se o SpeechRecognition está disponível
      const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
      if (!SpeechRecognition) {
        console.error('Speech Recognition não é suportado neste navegador.');
        return; // Saia se o reconhecimento de fala não estiver disponível
      }
      this.recognition = new SpeechRecognition();
      this.recognition.lang = 'pt-BR';
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.finalTranscripts = ''; // Reset final transcripts
      this.recognition.onresult = (event: any) => {
        let interimTranscripts = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            let date=new Date();
            let time=date.getTime()
            if ((time-this.lastMessage.time)<1000){
              let difference=this.getStringDifference(transcript, this.lastMessage.text);
              if (difference<10){return} 
            }
            this.finalTranscripts += this._appData.instagramUser.full_name + ': '+ transcript + ' ';
            let channel={
              x:this._appData.instagramUser.position.x,
              y:this._appData.instagramUser.position.y,
              z:this._appData.instagramUser.position.z
            }
            let msgObj={
              _id: time,
              createdAt: time,
              text: transcript +'.',
              event:this._appData.event.id.toString(),
              channel:channel,
              recording:true,
              link:'',
              user:{
                _id: this._appData.instagramUser.uid,
                avatar:this._appData.instagramUser.profile_picture,
                name: this._appData.instagramUser.full_name,
                token:''
              }
        }
        var talkTo=""
        this._companyService.messageWriteToLocalPosition(this.room,msgObj)
  

          } else {
            interimTranscripts += transcript;
          }
        }
        document.getElementById('transcriptionText')!.textContent = this.finalTranscripts + interimTranscripts;
        document.getElementById('transcriptionContainer')!.style.display = 'block';
      };
      this.recognition.onerror = (event: any) => {
        console.error('Erro na transcrição:', event.error);
        if (this.isRecognizing) {
          this.recognition.start();
        }
      };
      this.recognition.onend = () => {
        if (this.isRecognizing) {
          this.recognition.start();
        }
      };
      this.isRecognizing = true;
      this.recognition.start();
    }
    public stopRecognition() {
      if (this.recognition) {
        this.isRecognizing = false;
        this.recognition.stop();
      }
    }
    public updateRecordingTime() {
      const elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
      const minutes = String(Math.floor(elapsedTime / 60)).padStart(2, '0');
      const seconds = String(elapsedTime % 60).padStart(2, '0');
//      document.getElementById('recordingTime')!.textContent = `${minutes}:${seconds}`;
    }
    public updateButtonStates() {
      const startButton = document.getElementById('startBtn') as HTMLButtonElement;
      const pauseButton = document.getElementById('pauseBtn') as HTMLButtonElement;
      const stopButton = document.getElementById('stopBtn') as HTMLButtonElement;
      startButton.disabled = this.isRecording;
      pauseButton.disabled = !this.isRecording;
      stopButton.disabled = !this.isRecording;
    }
}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/chat-component/chat.component.ts